export const { REACT_APP_GA_TRACKING_ID, REACT_APP_TINYMCE_API_KEY } = process.env;
